/*
 * return-form.js — Returns lightbox.
 *
 * Posts each field as its own multipart part to FormBold. There is no
 * server hop. Duplicate file part names 400, so one file is `upload`
 * and several are `upload[0]`, `upload[1]`, `upload[2]`.
 */

(function () {
  var ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
  var FILE_FIELD = 'upload';
  var TEXT_FIELDS = [
    'motivo',
    'motivo_otro',
    'producto',
    'punto_compra',
    'numero_pedido',
    'numero_lote',
    'nombre',
    'apellidos',
    'email',
    'prefijo',
    'telefono'
  ];
  var STEP_ORDER = ['reason', 'product', 'details'];

  function fileFieldName(index, total) {
    return total === 1 ? FILE_FIELD : FILE_FIELD + '[' + index + ']';
  }

  function formatSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(1).replace(/\.0$/, '') + ' KB';
    return (bytes / 1048576).toFixed(1).replace(/\.0$/, '') + ' MB';
  }

  function trim(value) {
    return value ? String(value).trim() : '';
  }

  function initReturnForm(root) {
    var form = root.querySelector('[data-return-form-fields]');
    var title = root.querySelector('[data-return-form-title]');
    var defaultTitle = title ? title.textContent : '';
    var fileInput = root.querySelector('[data-file-input]');
    var fileList = root.querySelector('[data-file-list]');
    var fileCount = root.querySelector('[data-file-count]');
    var fileError = root.querySelector('[data-file-error]');
    var attachTrigger = root.querySelector('[data-attach-trigger]');
    var submit = root.querySelector('[data-submit]');
    var success = root.querySelector('[data-status-success]');
    var error = root.querySelector('[data-status-error]');
    var otherWrap = root.querySelector('[data-reason-other]');
    var noOrder = root.querySelector('[data-no-order]');
    var lotField = root.querySelector('[data-lot-field]');
    var otherNotice = root.querySelector('[data-other-notice]');
    var filesWrap = root.querySelector('[data-files]');
    var productNext = root.querySelector('[data-product-next]');
    var selectRoot = root.querySelector('[data-select]');
    var selectTrigger = root.querySelector('[data-select-trigger]');
    var selectList = root.querySelector('[data-select-list]');
    var selectValue = root.querySelector('[data-select-value]');
    var selectInput = root.querySelector('[data-select-input]');
    var selectField = root.querySelector('[data-select-field]');
    var productInput = root.querySelector('[data-product-input]');
    var productList = root.querySelector('[data-product-list]');
    var productCombo = root.querySelector('[data-product-suggest]');
    var consent = root.querySelector('[data-consent]');

    if (!form || !fileInput) return;

    var endpoint = root.dataset.endpoint;
    var maxFiles = parseInt(root.dataset.maxFiles, 10) || 3;
    var maxFileSize = parseInt(root.dataset.maxFileSize, 10) || 1024 * 1024;
    var files = [];
    var purchaseKey = '';
    var completed = { reason: false, product: false, details: false };
    var searchTimer = null;
    var searchAbort = null;
    var activeSuggest = -1;
    var SEARCH_DEBOUNCE_MS = 250;
    var SEARCH_LIMIT = 4;

    function stepEl(name) {
      return root.querySelector('[data-step="' + name + '"]');
    }

    function openStep(name) {
      closeSelect();
      closeSuggest();
      STEP_ORDER.forEach(function (id) {
        var el = stepEl(id);
        if (!el) return;
        var isOpen = id === name;
        el.classList.toggle('is-open', isOpen);
        var toggle = el.querySelector('[data-step-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function unlockThrough(name) {
      var index = STEP_ORDER.indexOf(name);
      STEP_ORDER.forEach(function (id, i) {
        var el = stepEl(id);
        if (!el) return;
        var toggle = el.querySelector('[data-step-toggle]');
        if (toggle) toggle.disabled = i > index && !completed[id];
      });
    }

    function selectedReason() {
      return form.querySelector('input[name="motivo"]:checked');
    }

    function reasonComplete() {
      var radio = selectedReason();
      if (!radio) return false;
      if (radio.getAttribute('data-reason') === 'other') {
        return trim(form.elements.motivo_otro && form.elements.motivo_otro.value).length > 0;
      }
      return true;
    }

    function isOtherPurchase() {
      return purchaseKey === 'otros';
    }

    function productComplete() {
      if (!trim(form.elements.producto && form.elements.producto.value)) return false;
      if (!purchaseKey || isOtherPurchase()) return false;
      if (noOrder && noOrder.checked) {
        return trim(form.elements.numero_lote && form.elements.numero_lote.value).length > 0;
      }
      return trim(form.elements.numero_pedido && form.elements.numero_pedido.value).length > 0;
    }

    function detailsComplete() {
      return (
        trim(form.elements.nombre && form.elements.nombre.value) &&
        trim(form.elements.apellidos && form.elements.apellidos.value) &&
        trim(form.elements.email && form.elements.email.value) &&
        form.elements.email.checkValidity() &&
        trim(form.elements.telefono && form.elements.telefono.value) &&
        consent &&
        consent.checked
      );
    }

    function setReasonNext() {
      var btn = stepEl('reason').querySelector('[data-step-next]');
      if (btn) btn.disabled = !reasonComplete();
    }

    function setProductNext() {
      if (!productNext) return;
      productNext.disabled = !productComplete();
      var understood = productNext.getAttribute('data-label-understood');
      var cont = productNext.getAttribute('data-label-continue');
      if (isOtherPurchase() && understood) productNext.textContent = understood;
      else if (cont) productNext.textContent = cont;
    }

    function setSubmit() {
      if (submit) submit.disabled = !detailsComplete();
    }

    function updateReasonOther() {
      var radio = selectedReason();
      var isOther = radio && radio.getAttribute('data-reason') === 'other';
      if (otherWrap) otherWrap.hidden = !isOther;
      if (!isOther && form.elements.motivo_otro) form.elements.motivo_otro.value = '';
      setReasonNext();
    }

    function updatePurchaseUi() {
      var other = isOtherPurchase();
      if (otherNotice) otherNotice.hidden = !other;
      if (filesWrap) filesWrap.hidden = other;
      if (attachTrigger) {
        attachTrigger.hidden = other;
        attachTrigger.disabled = other || files.length >= maxFiles;
      }
      setProductNext();
    }

    function updateOrderUi() {
      var without = noOrder && noOrder.checked;
      var orderInput = form.elements.numero_pedido;
      if (lotField) lotField.hidden = !without;
      if (orderInput) {
        orderInput.disabled = without;
        if (without) orderInput.value = '';
      }
      if (!without && form.elements.numero_lote) form.elements.numero_lote.value = '';
      setProductNext();
    }

    function reasonSummary() {
      var radio = selectedReason();
      return radio ? radio.value : '';
    }

    function productSummary() {
      var lines = [];
      var producto = trim(form.elements.producto && form.elements.producto.value);
      var punto = trim(selectInput && selectInput.value);
      var pedido = trim(form.elements.numero_pedido && form.elements.numero_pedido.value);
      var lote = trim(form.elements.numero_lote && form.elements.numero_lote.value);
      if (producto) lines.push(root.dataset.summaryProduct + producto);
      if (punto) lines.push(root.dataset.summaryPoint + punto);
      if (pedido) lines.push(root.dataset.summaryOrder + pedido);
      if (lote) lines.push(root.dataset.summaryLot + lote);
      if (files.length) lines.push(root.dataset.summaryFiles + String(files.length));
      return lines.join('\n');
    }

    function detailsSummary() {
      var lines = [];
      var nombre = trim(form.elements.nombre && form.elements.nombre.value);
      var apellidos = trim(form.elements.apellidos && form.elements.apellidos.value);
      var email = trim(form.elements.email && form.elements.email.value);
      var phone = trim(form.elements.telefono && form.elements.telefono.value);
      var prefix = trim(form.elements.prefijo && form.elements.prefijo.value);
      if (nombre) lines.push(root.dataset.summaryName + nombre);
      if (apellidos) lines.push(root.dataset.summaryLast + apellidos);
      if (email) lines.push(root.dataset.summaryEmail + email);
      if (phone) lines.push(root.dataset.summaryPhone + (prefix ? prefix + ' ' : '') + phone);
      return lines.join('\n');
    }

    function writeSummary(name, text) {
      var el = stepEl(name);
      if (!el) return;
      var summary = el.querySelector('[data-step-summary]');
      if (!summary) return;
      summary.textContent = text || '';
      summary.hidden = !text || el.classList.contains('is-open');
    }

    function refreshSummaries() {
      writeSummary('reason', completed.reason ? reasonSummary() : '');
      writeSummary('product', completed.product ? productSummary() : '');
      writeSummary('details', completed.details ? detailsSummary() : '');
    }

    function setFileError(message) {
      fileError.textContent = message || '';
      fileError.hidden = !message;
    }

    function validateFile(file) {
      if (ALLOWED_TYPES.indexOf(file.type) === -1) return root.dataset.errorFileType;
      if (file.size > maxFileSize) return root.dataset.errorFileSize;
      return null;
    }

    function revokeFiles() {
      files.forEach(function (entry) {
        if (entry.url) URL.revokeObjectURL(entry.url);
      });
    }

    function renderFiles() {
      fileList.textContent = '';

      files.forEach(function (entry, index) {
        var item = document.createElement('li');
        item.className = 'return-form__file-item';

        var thumb = document.createElement('img');
        thumb.className = 'return-form__file-thumb';
        thumb.alt = '';
        thumb.width = 40;
        thumb.height = 40;
        thumb.src = entry.url;

        var meta = document.createElement('div');
        meta.className = 'return-form__file-meta';

        var name = document.createElement('span');
        name.className = 'return-form__file-name body-2';
        name.textContent = entry.file.name;

        var size = document.createElement('span');
        size.className = 'return-form__file-size body-1';
        size.textContent = formatSize(entry.file.size);

        meta.appendChild(name);
        meta.appendChild(size);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'return-form__file-remove';
        remove.setAttribute('aria-label', root.dataset.labelRemove);
        remove.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">' +
          '<path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/>' +
          '</svg>';
        remove.addEventListener('click', function () {
          if (entry.url) URL.revokeObjectURL(entry.url);
          files.splice(index, 1);
          setFileError('');
          renderFiles();
        });

        item.appendChild(thumb);
        item.appendChild(meta);
        item.appendChild(remove);
        fileList.appendChild(item);
      });

      fileList.hidden = files.length === 0;
      fileCount.textContent = String(files.length);
      if (attachTrigger) {
        attachTrigger.disabled = isOtherPurchase() || files.length >= maxFiles;
      }
      fileInput.disabled = files.length >= maxFiles;
    }

    function closeSelect() {
      if (!selectList) return;
      selectList.hidden = true;
      if (selectField) selectField.classList.remove('is-open');
    }

    function closeSuggest() {
      if (searchTimer) {
        window.clearTimeout(searchTimer);
        searchTimer = null;
      }
      if (searchAbort) {
        searchAbort.abort();
        searchAbort = null;
      }
      activeSuggest = -1;
      if (productList) {
        productList.hidden = true;
        productList.textContent = '';
      }
      if (productInput) {
        productInput.setAttribute('aria-expanded', 'false');
        productInput.removeAttribute('aria-activedescendant');
      }
    }

    function suggestOptions() {
      if (!productList) return [];
      return Array.prototype.slice.call(productList.querySelectorAll('[data-product-option]'));
    }

    function highlightSuggest(index) {
      var options = suggestOptions();
      if (!options.length) {
        activeSuggest = -1;
        return;
      }
      if (index < 0) index = options.length - 1;
      if (index >= options.length) index = 0;
      activeSuggest = index;
      options.forEach(function (option, i) {
        var on = i === activeSuggest;
        option.classList.toggle('is-active', on);
        if (on && productInput) productInput.setAttribute('aria-activedescendant', option.id);
      });
    }

    function chooseSuggest(title) {
      if (!productInput || !title) return;
      productInput.value = title;
      closeSuggest();
      setProductNext();
    }

    function renderSuggest(products) {
      if (!productList || !productInput) return;
      productList.textContent = '';
      var titles = [];
      (products || []).forEach(function (product) {
        var title = trim(product && product.title);
        if (!title || titles.indexOf(title) !== -1) return;
        titles.push(title);
      });
      titles = titles.slice(0, SEARCH_LIMIT);
      if (!titles.length) {
        closeSuggest();
        return;
      }
      titles.forEach(function (title, index) {
        var item = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.id = 'return-form-product-opt-' + index;
        button.className = 'return-form__select-option body-2';
        button.setAttribute('role', 'option');
        button.setAttribute('data-product-option', '');
        button.textContent = title;
        item.appendChild(button);
        productList.appendChild(item);
      });
      productList.hidden = false;
      productInput.setAttribute('aria-expanded', 'true');
      activeSuggest = -1;
    }

    function predictiveUrl(query) {
      var base = root.getAttribute('data-predictive-search-url') || '/search/suggest.json';
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', String(SEARCH_LIMIT));
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      return base + '?' + params.toString();
    }

    function fetchSuggest(query) {
      if (searchAbort) searchAbort.abort();
      var controller = new AbortController();
      searchAbort = controller;
      return fetch(predictiveUrl(query), {
        signal: controller.signal,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('search');
        return response.json();
      }).then(function (data) {
        var resources = (data && data.resources && data.resources.results) || {};
        return Array.isArray(resources.products) ? resources.products : [];
      });
    }

    function scheduleSuggest(query) {
      if (searchTimer) window.clearTimeout(searchTimer);
      var q = trim(query);
      if (!q) {
        closeSuggest();
        return;
      }
      searchTimer = window.setTimeout(function () {
        searchTimer = null;
        fetchSuggest(q)
          .then(function (products) {
            if (trim(productInput && productInput.value) !== q) return;
            renderSuggest(products);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            closeSuggest();
          });
      }, SEARCH_DEBOUNCE_MS);
    }

    function setPurchase(key, label) {
      purchaseKey = key || '';
      if (selectInput) selectInput.value = label || '';
      if (selectValue) selectValue.textContent = label || '';
      closeSelect();
      updatePurchaseUi();
    }

    function showStatus(panel) {
      form.hidden = true;
      success.hidden = true;
      error.hidden = true;
      panel.hidden = false;
      if (title && panel === success) {
        var name = trim(form.elements.nombre && form.elements.nombre.value);
        title.textContent = (root.dataset.successThanks || '').replace('__NAME__', name);
      }
    }

    function reset(keepOpen) {
      form.reset();
      revokeFiles();
      files = [];
      purchaseKey = '';
      completed = { reason: false, product: false, details: false };
      setFileError('');
      renderFiles();
      if (selectValue) selectValue.textContent = '';
      if (selectInput) selectInput.value = '';
      closeSelect();
      closeSuggest();
      updateReasonOther();
      updateOrderUi();
      updatePurchaseUi();
      setSubmit();
      success.hidden = true;
      error.hidden = true;
      form.hidden = false;
      if (title) title.textContent = defaultTitle;
      openStep('reason');
      unlockThrough('reason');
      refreshSummaries();
      if (!keepOpen) close();
    }

    function open() {
      root.hidden = false;
      document.body.classList.add('is-return-form-open');
      if (history.replaceState && window.location.hash !== '#return-form') {
        history.replaceState(null, '', window.location.pathname + window.location.search + '#return-form');
      }
      var closeBtn = root.querySelector('.return-form__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.hidden = true;
      document.body.classList.remove('is-return-form-open');
      if (window.location.hash === '#return-form') {
        if (history.replaceState) history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    function goTo(name) {
      var index = STEP_ORDER.indexOf(name);
      if (index < 0) return;
      if (index >= 1 && !completed.reason) return;
      if (index >= 2 && !completed.product) return;
      openStep(name);
      refreshSummaries();
    }

    form.addEventListener('change', function (event) {
      if (event.target.name === 'motivo') updateReasonOther();
      if (event.target === noOrder) updateOrderUi();
      if (event.target === consent) setSubmit();
    });

    form.addEventListener('input', function (event) {
      var name = event.target.name;
      if (name === 'motivo_otro') setReasonNext();
      if (name === 'producto' || name === 'numero_pedido' || name === 'numero_lote') setProductNext();
      if (name === 'producto') {
        closeSelect();
        scheduleSuggest(event.target.value);
      }
      if (name === 'nombre' || name === 'apellidos' || name === 'email' || name === 'telefono' || name === 'prefijo') {
        setSubmit();
      }
    });

    form.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-step-toggle]');
      if (toggle) {
        var step = toggle.closest('[data-step]');
        if (!step || toggle.disabled) return;
        var name = step.getAttribute('data-step');
        if (step.classList.contains('is-open')) return;
        goTo(name);
        return;
      }

      var next = event.target.closest('[data-step-next]');
      if (next) {
        var target = next.getAttribute('data-step-next');
        if (target === 'product' && reasonComplete()) {
          completed.reason = true;
          unlockThrough('product');
          goTo('product');
        }
        if (target === 'details' && productComplete()) {
          completed.product = true;
          unlockThrough('details');
          goTo('details');
        }
      }
    });

    if (selectTrigger) {
      selectTrigger.addEventListener('click', function () {
        closeSuggest();
        var openList = selectList.hidden;
        selectList.hidden = !openList;
        if (selectField) selectField.classList.toggle('is-open', openList);
      });
    }

    if (selectList) {
      selectList.addEventListener('click', function (event) {
        var option = event.target.closest('[data-select-option]');
        if (!option) return;
        setPurchase(option.getAttribute('data-select-option'), option.textContent.trim());
      });
    }

    if (productList) {
      productList.addEventListener('mousedown', function (event) {
        event.preventDefault();
      });
      productList.addEventListener('click', function (event) {
        var option = event.target.closest('[data-product-option]');
        if (!option) return;
        chooseSuggest(option.textContent.trim());
      });
    }

    if (productInput) {
      productInput.addEventListener('keydown', function (event) {
        if (productList && productList.hidden) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          highlightSuggest(activeSuggest + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          highlightSuggest(activeSuggest - 1);
        } else if (event.key === 'Enter' && activeSuggest >= 0) {
          var options = suggestOptions();
          if (!options[activeSuggest]) return;
          event.preventDefault();
          chooseSuggest(options[activeSuggest].textContent.trim());
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          closeSuggest();
        }
      });
      productInput.addEventListener('blur', function () {
        window.setTimeout(closeSuggest, 120);
      });
    }

    attachTrigger.addEventListener('click', function () {
      if (attachTrigger.disabled) return;
      fileInput.click();
    });

    fileInput.addEventListener('change', function () {
      var selected = Array.prototype.slice.call(fileInput.files);
      fileInput.value = '';
      setFileError('');
      if (!selected.length) return;

      if (files.length + selected.length > maxFiles) {
        setFileError(root.dataset.errorMaxFiles);
        return;
      }

      for (var i = 0; i < selected.length; i += 1) {
        var message = validateFile(selected[i]);
        if (message) {
          setFileError(message);
          return;
        }
      }

      selected.forEach(function (file) {
        files.push({ file: file, url: URL.createObjectURL(file) });
      });
      renderFiles();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!detailsComplete() || !productComplete() || !reasonComplete()) return;

      var payload = new FormData();

      TEXT_FIELDS.forEach(function (name) {
        var field = form.elements[name];
        var value = field ? trim(field.value) : '';
        if (name === 'motivo_otro' && selectedReason() && selectedReason().getAttribute('data-reason') !== 'other') {
          return;
        }
        if (name === 'numero_pedido' && noOrder && noOrder.checked) return;
        if (name === 'numero_lote' && !(noOrder && noOrder.checked)) return;
        if (value) payload.append(name, value);
      });

      files.forEach(function (entry, index) {
        payload.append(fileFieldName(index, files.length), entry.file);
      });

      completed.details = true;
      submit.disabled = true;
      submit.textContent = root.dataset.labelSending;

      var emailEl = root.querySelector('[data-success-email]');
      if (emailEl) emailEl.textContent = trim(form.elements.email.value);

      fetch(endpoint, { method: 'POST', body: payload })
        .then(function (response) {
          showStatus(response.ok ? success : error);
        })
        .catch(function () {
          showStatus(error);
        })
        .then(function () {
          submit.disabled = false;
          submit.textContent = root.dataset.labelSubmit;
          setSubmit();
        });
    });

    root.querySelectorAll('[data-reset]').forEach(function (button) {
      button.addEventListener('click', function () {
        error.hidden = true;
        form.hidden = false;
        if (title) title.textContent = defaultTitle;
        openStep('details');
      });
    });

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('a[href*="return-form"]');
      if (opener && root.contains(opener) === false) {
        event.preventDefault();
        open();
        return;
      }
      if (selectList && !selectList.hidden && selectRoot && !selectRoot.contains(event.target)) {
        closeSelect();
      }
      if (productList && !productList.hidden && productCombo && !productCombo.contains(event.target)) {
        closeSuggest();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (root.hidden) return;
      if (event.key !== 'Escape') return;
      event.preventDefault();
      if (productList && !productList.hidden) {
        closeSuggest();
        return;
      }
      if (selectList && !selectList.hidden) {
        closeSelect();
        return;
      }
      close();
    });

    root.querySelectorAll('[data-return-form-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!success.hidden || !error.hidden) reset(false);
        else close();
      });
    });

    if (productNext) {
      productNext.setAttribute('data-label-continue', productNext.textContent);
    }

    updateReasonOther();
    updateOrderUi();
    updatePurchaseUi();
    renderFiles();
    setSubmit();

    if (window.location.hash === '#return-form') open();
  }

  function start() {
    document.querySelectorAll('[data-return-form]').forEach(initReturnForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
